import React from "react";
import {Box, ButtonBase, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Tick02Icon} from "@hugeicons/core-free-icons";

const SWATCH = 30;
const isHex = (value) => /^#[0-9a-f]{6}$/i.test(String(value || ""));

const Swatch = ({color, selected, onClick}) => (
  <ButtonBase onClick={onClick} aria-label={`Color ${color}`} aria-pressed={selected} sx={{
    width: SWATCH, height: SWATCH, borderRadius: "50%", bgcolor: color, color: "#fff", flexShrink: 0,
    boxShadow: selected ? `0 0 0 2px #fff, 0 0 0 4px ${color}` : "none",
    transition: "box-shadow .15s ease, transform .15s ease", "&:hover": {transform: "scale(1.08)"},
  }}>
    {selected && <HugeiconsIcon icon={Tick02Icon} size={16} strokeWidth={2.5}/>}
  </ButtonBase>
);

export const ColorSwatchPicker = ({value, onChange, colors, defaultLabel, defaultHint}) => {
  const current = String(value || "").toLowerCase();
  const custom = isHex(current) && !colors.includes(current);

  return (
    <Stack direction={"row"} alignItems={"center"} gap={1.25} flexWrap={"wrap"} sx={{px: 0.5, py: 0.5}}>
      {defaultLabel && (
        <ButtonBase onClick={() => onChange("")} aria-label={"Default color"} aria-pressed={!current} sx={{
          height: SWATCH, px: 1.25, borderRadius: "999px", fontSize: 12, fontWeight: 700,
          color: !current ? "#4B55C9" : "#6B6B80", bgcolor: !current ? "rgba(132, 145, 247, 0.18)" : "#F2F2F7",
        }}>
          {defaultLabel}
        </ButtonBase>
      )}
      {colors.map(color => (
        <Swatch key={color} color={color} selected={current === color} onClick={() => onChange(color)}/>
      ))}
      <Box sx={{position: "relative", width: SWATCH, height: SWATCH, flexShrink: 0}}>
        <Box sx={{
          width: SWATCH, height: SWATCH, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", pointerEvents: "none",
          background: custom ? current : "conic-gradient(#F27BA5, #F5A272, #4CC38A, #5DA9E9, #C77DD4, #8491F7, #F27BA5)",
          boxShadow: custom ? `0 0 0 2px #fff, 0 0 0 4px ${current}` : "none",
        }}>
          {custom && <HugeiconsIcon icon={Tick02Icon} size={16} strokeWidth={2.5}/>}
        </Box>
        <Box
          component={"input"}
          type={"color"}
          value={isHex(current) ? current : colors[0]}
          onChange={(event) => onChange(event.target.value.toLowerCase())}
          aria-label={"Pick a custom color"}
          sx={{position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", p: 0, border: 0}}
        />
      </Box>
      <Typography sx={{fontSize: 12, color: "#8A8AA0"}}>{current ? current.toUpperCase() : defaultHint}</Typography>
    </Stack>
  );
};
